export const selectLinkedinPromotionState = (state) => state.linkedinPromotion;
export const selectLinkedinPromotionTotalStats = (state) => state.linkedinPromotion.totalStats || {};
